const clickSelectItem = () => {
  const selectItems = document.querySelectorAll('.js-document-select-item');
  const SELECTED_CLASS = 'is-selected';

  if (selectItems.length === 0) return;

  const checkBox = e => {
    const checkbox = e.querySelector('input[type="checkbox"]');

    if (e.classList.contains(SELECTED_CLASS)) {
      checkbox.checked = true;
    } else {
      checkbox.checked = false;
    }
  };

  const clickHandler = (e) => {
    const _this = e.currentTarget;

    if (_this.classList.contains(SELECTED_CLASS)) {
      _this.classList.remove(SELECTED_CLASS);
    } else {
      _this.classList.add(SELECTED_CLASS);
    }

    checkBox(_this);
  };

  selectItems.forEach(item => {
    checkBox(item);
    item.addEventListener('click', clickHandler);
  });

};

const init = () => {
  clickSelectItem();
};

export default init;
